import React from 'react'
import Navbar from '../components/marketing/Navigation'
import Footer from '../components/marketing/Footer'

export default function Privacy() {
    return (
        <div className="font-body text-brand-charcoal bg-white min-h-screen flex flex-col">
            <Navbar />

            <main className="flex-grow py-16 lg:py-24">
                <div className="container mx-auto px-6 max-w-3xl">
                    <h1 className="font-heading text-4xl font-bold text-brand-green mb-8">Privacy Policy</h1>

                    <p className="text-brand-slate mb-6">
                        <strong>Last updated:</strong> December 2024
                    </p>

                    <div className="prose prose-lg max-w-none text-brand-charcoal">
                        <p className="mb-6">
                            Bench Bulletin ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share information when you use our scrimmage finder and team management platform.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">Information We Collect</h2>

                        <h3 className="font-heading text-lg font-semibold mt-6 mb-3">Account Information</h3>
                        <p className="mb-4 text-brand-slate">
                            When you create an account, we collect your email address and the team information you provide (team name, association, level, etc.).
                        </p>

                        <h3 className="font-heading text-lg font-semibold mt-6 mb-3">Calendar Data</h3>
                        <p className="mb-4 text-brand-slate">
                            If you choose to sync your team's calendar, we access the calendar URL you provide to scan for schedule conflicts and matching opportunities. We only read publicly available calendar data.
                        </p>

                        <h3 className="font-heading text-lg font-semibold mt-6 mb-3">Usage Data</h3>
                        <p className="mb-4 text-brand-slate">
                            We collect information about how you use our service, including pages visited, features used, and interactions with the scrimmage bulletin.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">How We Use Your Information</h2>
                        <ul className="list-disc pl-6 mb-6 space-y-2 text-brand-slate">
                            <li>To provide and improve our scrimmage finding and team management services</li>
                            <li>To match you with relevant scrimmage opportunities</li>
                            <li>To send you notifications about matches and team updates (with your consent)</li>
                            <li>To communicate with you about your account and our services</li>
                        </ul>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">Information Sharing</h2>
                        <p className="mb-4 text-brand-slate">
                            We do not sell your personal information. We may share limited information in these circumstances:
                        </p>
                        <ul className="list-disc pl-6 mb-6 space-y-2 text-brand-slate">
                            <li><strong>With other managers:</strong> When you request a scrimmage, your team name and contact information are shared with the other team's manager.</li>
                            <li><strong>Service providers:</strong> We use trusted third-party services (hosting, email delivery, payment processing) that may access data to perform their services.</li>
                            <li><strong>Legal requirements:</strong> We may disclose information if required by law.</li>
                        </ul>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">Data Security</h2>
                        <p className="mb-4 text-brand-slate">
                            We use industry-standard security measures to protect your data, including encryption in transit and at rest. Your data is stored on secure servers with limited access.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">Youth Privacy (COPPA)</h2>
                        <p className="mb-4 text-brand-slate">
                            Our service is designed for team managers (adults), not children. We do not knowingly collect personal information from children under 13. If you believe a child has provided us with personal information, please contact us.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">Your Rights</h2>
                        <p className="mb-4 text-brand-slate">
                            You can access, update, or delete your account information at any time through your dashboard. To request a complete deletion of your data, email us at support@benchbulletin.com.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">Contact Us</h2>
                        <p className="mb-4 text-brand-slate">
                            If you have questions about this Privacy Policy, please contact us at:
                        </p>
                        <p className="text-brand-slate">
                            <strong>Email:</strong> <a href="mailto:support@benchbulletin.com" className="text-brand-green hover:underline">support@benchbulletin.com</a>
                        </p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    )
}
